(function () {
  const data_element = document.getElementById("theme-tracking-data");

  if (!data_element || (window.Theme && window.Theme.redirecting)) {
    return;
  }

  const config = JSON.parse(data_element.textContent);

  const UTM_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_platform",
    "utm_creative_format",
    "utm_marketing_tactic"
  ];

  const ATTRIBUTE_KEYS = ["google-clientID", "google-sessionID", ...UTM_PARAMS, "transaction_id"];

  const CHECKOUT_SYNC_TIMEOUT = 1500;

  const AMAZON_PIXEL_ID = "d8fa6bc1-8325-4e4f-f62a-2d40b80730a6";

  const AMAZON_PIXEL_SRC = "//s.amazon-adsystem.com/iu3?d=generic&ex-fargs=%3Fid%3Dd8fa6bc1-8325-4e4f-f62a-2d40b80730a6%26type%3D55%26m%3D1&ex-fch=416613&ex-src=https://www.takearecess.com/&ex-hargs=v%3D1.0%3Bc%3D4133329570701%3Bp%3DD8FA6BC1-8325-4E4F-F62A-2D40B80730A6";

  const AMAZON_AD_TAG = "b5e54875-614f-4a64-9ebe-931f2b6fa94a";

  const ASPIRE_DOMAIN = "https://aspireiq.go2cloud.org";

  const params = new URLSearchParams(window.location.search);

  const state = {
    client_id: null,
    session_id: null,
    cart: null
  };

  window.dataLayer = window.dataLayer || [];

  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  function stored(key) {
    return window.Theme && window.Theme.Attribution ? window.Theme.Attribution.get(key) : undefined;
  }

  function push(payload) {
    window.dataLayer.push(payload);
  }

  function product_gid(id) {
    return `gid://shopify/Product/${id}`;
  }

  function cart_id() {
    return state.cart && state.cart.token ? `gid://shopify/Cart/${state.cart.token}` : undefined;
  }

  function client_id() {
    return state.client_id || undefined;
  }

  function setup_analytics() {
    const incoming_client_id = params.get("googleClientId");
    const incoming_session_id = params.get("googleSessionId");

    const options = {
      send_page_view: false,
      cookie_domain: "auto",
      linker: {
        domains: config.linker_domains,
        accept_incoming: true
      }
    };

    if (incoming_client_id) {
      options.client_id = incoming_client_id;
    }

    if (incoming_session_id) {
      options.session_id = Number(incoming_session_id);
    }

    window.gtag("js", new Date());
    window.gtag("config", config.ga4_id, options);

    if (incoming_client_id) {
      set_ids(incoming_client_id, incoming_session_id);

      return;
    }

    window.gtag("get", config.ga4_id, "client_id", (google_client_id) => {
      window.gtag("get", config.ga4_id, "session_id", (google_session_id) => {
        set_ids(google_client_id, google_session_id);
      });
    });
  }

  function set_ids(google_client_id, google_session_id) {
    state.client_id = google_client_id ? String(google_client_id) : null;
    state.session_id = google_session_id ? String(google_session_id) : null;

    window.googleClientId = state.client_id;

    sync_cart_attributes();
  }

  function fetch_cart() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        state.cart = cart;

        return cart;
      });
  }

  function tracking_attributes() {
    const attributes = {};

    if (state.client_id) {
      attributes["google-clientID"] = state.client_id;
    }

    if (state.session_id) {
      attributes["google-sessionID"] = state.session_id;
    }

    if (Object.keys(attributes).length > 0) {
      Object.assign(attributes, stored("utm") || {}, stored("aspire") || {});
    }

    return attributes;
  }

  function sync_cart_attributes() {
    const attributes = tracking_attributes();

    if (Object.keys(attributes).length === 0) {
      return Promise.resolve();
    }

    return fetch_cart()
      .then((cart) => {
        if (!cart.item_count) {
          return;
        }

        const current = cart.attributes || {};
        const update = {};

        ATTRIBUTE_KEYS.forEach((key) => {
          const desired = attributes[key] || "";

          if (desired !== (current[key] || "")) {
            update[key] = desired;
          }
        });

        if (Object.keys(update).length === 0) {
          return;
        }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ attributes: update })
        })
          .then((response) => response.json())
          .then((updated_cart) => {
            state.cart = updated_cart;
          });
      })
      .catch((error) => {
        console.error("Tracking cart attributes failed", error);
      });
  }

  function form_input(name) {
    return document.querySelector(`form[action*='/cart/add'] [name=${name}]`);
  }

  function selected_quantity() {
    const input = form_input("quantity");

    return (input && Number(input.value)) || 1;
  }

  function track_add_to_cart(item) {
    if (!item || !item.product_id) {
      return;
    }

    const quantity = Number(item.quantity_added || item.quantity) || 1;
    const price = (item.price / 100).toFixed(2);
    const gid = product_gid(item.product_id);
    const variant = item.variant_title || item.product_title;
    const url = `${window.location.origin}/products/${item.handle}`;

    push({
      event: "Add To Cart",
      google_client_id: client_id(),
      cart_id: cart_id(),
      product_id: gid,
      product_id_shopify: String(item.product_id),
      sku: item.sku,
      name: item.product_title,
      variant: variant,
      price: price,
      quantity: quantity,
      url: url
    });

    const selling_plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;

    window.gtag("event", "cart_add", {
      currency: config.currency,
      value: Number((price * quantity).toFixed(2)),
      purchase_type: selling_plan ? "subscription" : "one_time",
      selling_plan: selling_plan ? selling_plan.name : undefined,
      items: [
        {
          item_id: gid,
          item_name: item.product_title,
          item_variant: variant,
          item_category: item.product_type,
          price: price,
          quantity: quantity
        }
      ]
    });

    sync_cart_attributes();
  }

  function track_variant_change(variant_id) {
    const variants = config.product && config.product.variants;
    const variant = variants && variants[String(variant_id)];

    if (!variant) {
      return;
    }

    push({
      event: "Product Viewed",
      google_client_id: client_id(),
      product_id: product_gid(variant.product_id),
      sku: variant.sku,
      name: variant.name,
      variant: variant.variant,
      price: variant.price,
      quantity: selected_quantity(),
      value: variant.price,
      url: variant.url
    });
  }

  function track_product_list() {
    if (!config.collection) {
      return;
    }

    push({
      event: "Product List Viewed",
      google_client_id: client_id(),
      list_id: config.collection.list_id,
      category: config.collection.category,
      products: config.collection.products
    });
  }

  function track_amazon_click(event) {
    const link = event.target.closest("a[href*='amazon.com'], a[href*='amzn.to']");

    if (!link || !config.product) {
      return;
    }

    const single = config.product.variants[String(config.product.single_variant)];

    if (!single) {
      return;
    }

    const id_input = form_input("id");
    const selected = (id_input && config.product.variants[String(id_input.value)]) || single;
    const gid = product_gid(single.product_id);

    push({
      event: "Add To Cart - Amazon",
      google_client_id: client_id(),
      cart_id: cart_id(),
      product_id: gid,
      product_id_shopify: String(single.product_id),
      sku: selected.sku,
      name: single.name,
      variant: selected.variant,
      price: selected.price,
      quantity: 1,
      url: single.url,
      content_name: document.title,
      content_category: "amazon product page",
      content_ids: [gid],
      content_id: gid,
      content_type: "product",
      currency: config.currency
    });
  }

  function track_retailer_click(event) {
    const link = event.target.closest("a[data-retailer]");

    if (link) {
      const channel = link.dataset.channel === "delivery" ? "delivery_click" : "retailer_click";

      window.gtag("event", channel, {
        retailer: link.dataset.retailer,
        placement: config.placement
      });

      return;
    }

    const cerros = event.target.closest(".cb-online a[href]");

    if (cerros) {
      window.gtag("event", "retailer_click", {
        retailer: retailer_from_href(cerros.href),
        placement: config.placement,
        tab: "online"
      });
    }
  }

  function retailer_from_href(href) {
    try {
      const parts = new URL(href).hostname.split(".");

      return parts.length > 1 ? parts[parts.length - 2] : parts[0];
    } catch (error) {
      return undefined;
    }
  }

  function track_locator_click(event) {
    window.gtag("event", "store_locator_click", {
      placement: config.placement,
      tab: event.detail && event.detail.tab
    });
  }

  function track_locator_search(event) {
    window.gtag("event", "store_locator_search", {
      placement: config.placement,
      tab: event.detail && event.detail.tab
    });
  }

  function track_locator_form(event) {
    if (!event.target.closest("[data-locator-find]")) {
      return;
    }

    window.gtag("event", "store_locator_click", {
      placement: config.placement
    });
  }

  function track_newsletter_subscribe(event) {
    push({
      event: "Lead",
      google_client_id: client_id(),
      email: event.detail.email
    });
  }

  function checkout_url(href) {
    const url = new URL(href, window.location.origin);

    const values = Object.assign(
      {
        ga4MeasurementId: config.ga4_id,
        _ga: state.client_id,
        googleClientId: state.client_id,
        googleSessionId: state.session_id,
        origin: stored("origin_landing_page") || window.location.href,
        cart_token: state.cart && state.cart.token
      },
      stored("utm") || {},
      stored("aspire") || {}
    );

    Object.entries(values).forEach(([name, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.append(name, String(value));
      }
    });

    return url.toString();
  }

  function decorate_checkout(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest("a[href='/checkout'], a[href^='/checkout?']");

    if (!link) {
      return;
    }

    event.preventDefault();

    const href = link.getAttribute("href");
    const timeout = new Promise((resolve) => setTimeout(resolve, CHECKOUT_SYNC_TIMEOUT));

    Promise.race([sync_cart_attributes(), timeout]).then(() => {
      window.location.assign(checkout_url(href));
    });
  }

  function load_amazon() {
    if (!document.getElementById(`_pix_id_${AMAZON_PIXEL_ID}`)) {
      const pixel = document.createElement("iframe");

      pixel.style.display = "none";
      pixel.id = `_pix_id_${AMAZON_PIXEL_ID}`;
      pixel.src = `${AMAZON_PIXEL_SRC}&cb=${Math.random() * 1000000000000000000}`;

      document.body.appendChild(pixel);
    }

    if (window.amzn) {
      return;
    }

    const amzn = function () {
      amzn.q.push([arguments, new Date().getTime()]);
    };

    amzn.q = [];
    amzn.version = "0.0";

    window.amzn = amzn;

    const script = document.createElement("script");

    script.src = "https://c.amazon-adsystem.com/aat/amzn.js";
    script.id = "amzn-pixel";
    script.async = true;

    document.head.appendChild(script);

    window.amzn("setRegion", "NA");
    window.amzn("addTag", AMAZON_AD_TAG);
    window.amzn("trackEvent", "PageView");
  }

  function load_aspire() {
    const tdl = (window.tdl = window.tdl || []);

    if (tdl.invoked) {
      return;
    }

    tdl.invoked = true;
    tdl.methods = ["init", "identify", "convert"];

    tdl.factory = function (method) {
      return function () {
        const args = Array.prototype.slice.call(arguments);

        args.unshift(method);
        tdl.push(args);

        return tdl;
      };
    };

    tdl.methods.forEach((method) => {
      tdl[method] = tdl.factory(method);
    });

    tdl.init = function (domain) {
      const script = document.createElement("script");

      script.async = true;
      script.src = "https://js.go2sdk.com/v2/tune.js";

      document.head.appendChild(script);

      tdl.domain = domain;
    };

    tdl.init(ASPIRE_DOMAIN);
    tdl.identify();
  }

  setup_analytics();

  fetch_cart().catch((error) => {
    console.error("Tracking cart fetch failed", error);
  });

  load_amazon();
  load_aspire();
  track_product_list();

  document.addEventListener("addtocart", (event) => {
    track_add_to_cart(event.detail);
  });

  document.addEventListener("cartdrawer:upsell", (event) => {
    event.detail.items.forEach((item) => {
      track_add_to_cart({ ...item, quantity_added: event.detail.quantity });
    });
  });

  document.addEventListener("productform:variantchange", (event) => {
    track_variant_change(event.detail.variant_id);
  });

  document.addEventListener("productformvariants:change", (event) => {
    if (event.detail.variant) {
      track_variant_change(event.detail.variant.id);
    }
  });

  document.addEventListener("click", track_amazon_click);
  document.addEventListener("click", track_retailer_click);
  document.addEventListener("locator:find", track_locator_click);
  document.addEventListener("locator:search", track_locator_search);
  document.addEventListener("submit", track_locator_form);
  document.addEventListener("click", decorate_checkout);
  document.addEventListener("newsletter:subscribe", track_newsletter_subscribe);
})();
